import styled from 'styled-components';

import { HOME_NARROW, GRADIENTS } from '../../theme/tokens';

/**
 * Home dashboard column. Sections are separated by their own `.section-head`
 * margins (the source has no container `gap`), so this is a plain block column;
 * the two-column row and the spaced lower card set their own top margins.
 */
export const HomePage = styled.div`
  min-width: 0;
`;

/** Financial Performance (flexible) + Money Flow (fixed 355px rail). Collapses to
 *  one column at 1120px. */
export const TwoCol = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 355px;
  gap: 10px;
  margin-top: 10px;

  > * {
    min-width: 0;
  }

  ${HOME_NARROW} {
    grid-template-columns: 1fr;
  }
`;

/** A lower card spaced from the row above it (Acquisition Channels). */
export const SpacedCard = styled.div`
  margin-top: 10px;
`;

/** Hairline divider between "Brand Deployment" and "Business Optimization
 *  Score": a 24px gap, the rule, then another 24px gap before the section starts.
 *  A soft gradient line that fades to transparent at both edges (matches the
 *  Review & Pay billing-summary divider).
 *
 *  A `div`, not an `hr`: the global Bootstrap reboot forces `hr { opacity: .25 }`,
 *  which would knock the already-translucent gradient down to near-invisible. */
export const SectionDivider = styled.div`
  height: 2px;
  width: 100%;
  margin: 24px 0;
  background: ${GRADIENTS.fadeDivider};
`;

/** The interval picker, in the section header's right slot. Never shrinks: it
 *  reserves the picker's full width so the header title wraps to make room for it
 *  (dropping words to new lines) instead of the picker overflowing the pill. */
export const PickerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;
